(() => {
  const parseList = (value, fallback) => {
    if (!value) return fallback;
    return value
      .split(',')
      .map((part) => Number(part.trim()))
      .filter((part) => !Number.isNaN(part));
  };

  const measureGap = (root) => {
    const probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:var(--swiper-gap, 1.25rem);';
    root.appendChild(probe);
    const width = probe.getBoundingClientRect().width;
    probe.remove();
    return Number.isFinite(width) ? width : 20;
  };

  const mount = (root) => {
    if (!(root instanceof HTMLElement) || typeof window.Swiper !== 'function' || root.swiperInstance) return;

    const element = root.querySelector('.swiper');
    if (!element) return;

    const slides = parseList(root.dataset.slides, [1]);
    const breaks = parseList(root.dataset.breaks, [0]);
    const gap = measureGap(root);
    const breakpoints = {};

    breaks.forEach((min, index) => {
      if (min <= 0) return;
      breakpoints[min] = {
        slidesPerView: slides[index] || slides[slides.length - 1],
        spaceBetween: gap,
      };
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayDelay = Number(root.dataset.autoplay) || 0;
    const slideCount = element.querySelectorAll('.swiper-slide').length;
    const maxPerView = Math.max(...slides, 1);
    const autoMove = autoplayDelay > 0 && !reduceMotion && slideCount > maxPerView;

    const options = {
      slidesPerView: slides[0] || 1,
      spaceBetween: gap,
      speed: reduceMotion ? 0 : 450,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        enabled: true,
        prevSlideMessage: root.dataset.prevLabel || 'Previous products',
        nextSlideMessage: root.dataset.nextLabel || 'Next products',
      },
      navigation: {
        prevEl: root.querySelector('[data-swiper-prev]'),
        nextEl: root.querySelector('[data-swiper-next]'),
      },
      breakpoints,
    };

    if (autoMove) {
      options.speed = 700;
      options.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
      if (slideCount >= maxPerView * 2) {
        options.loop = true;
      } else {
        options.rewind = true;
      }
    }

    root.swiperInstance = new window.Swiper(element, options);
  };

  const scan = (scope) => {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    scope.querySelectorAll('[data-swiper]').forEach(mount);
  };

  const refreshGaps = () => {
    document.querySelectorAll('[data-swiper]').forEach((root) => {
      const instance = root.swiperInstance;
      if (!instance) return;
      const gap = measureGap(root);
      instance.params.spaceBetween = gap;
      Object.values(instance.params.breakpoints || {}).forEach((breakpoint) => {
        breakpoint.spaceBetween = gap;
      });
      instance.update();
    });
  };

  if (window.__themeSwiperBooted) return;
  window.__themeSwiperBooted = true;

  const boot = () => scan(document);

  document.addEventListener('theme:swiper:scan', (event) => {
    const scope = event.target instanceof Element ? event.target : document;
    scan(scope);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-swiper]').forEach((root) => {
      if (!root.swiperInstance) return;
      root.swiperInstance.destroy(true, true);
      root.swiperInstance = null;
    });
  });

  window.addEventListener('resize', refreshGaps);
})();
